module.exports = __webpack_public_path__ + "img/resumeLogin.7119e899.jpg";